import {loadBaseWebGlImageCanvas, renderWebgl, setUniforms} from './webgl_helpers.js';

export async function pixelBinarize({ image, threshold, color, is_alpha_binarize = false }) {
  color = color ?? [0.0, 0.0, 0.0]; // default color is black
  const { gl, webglProgram } = loadBaseWebGlImageCanvas({
    image,
    fragmentShaderSrc: `
      precision mediump float;
      uniform sampler2D u_image;
      uniform vec2 u_resolution;
      uniform float u_alpha_threshold;
      uniform float u_is_alpha_binarize;
      uniform vec3 u_color;
      
      varying vec2 v_texCoord;
      vec4 binarize(vec4 input_pixel) {
          if (input_pixel.a > u_alpha_threshold) {
              return vec4(u_color, u_is_alpha_binarize == 1.0 ? 1.0 : input_pixel.a);
          } else {
              return vec4(0.0, 0.0, 0.0, 0.0);
          }
      }
      void main() {
          gl_FragColor = binarize(texture2D(u_image, v_texCoord));
      }
    `,
  });
  
  setUniforms({
    gl,
    webglProgram,
    uniforms: [
      { name: 'u_flipY', type: '1f', values: [-1.0] },
      { name: 'u_alpha_threshold', type: '1f', values: [threshold] },
      { name: 'u_is_alpha_binarize', type: '1f', values: [is_alpha_binarize ? 1.0 : 0.0] },
      {
        name: 'u_resolution',
        type: '2f',
        values: [gl.canvas.width, gl.canvas.height],
      },
      { name: 'u_color', type: '3f', values: color },
    ],
  });
  renderWebgl({ gl, points: 6 });
  
  return gl.canvas.toDataURL('image/png', 1);
}
